import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Md5 } from 'ts-md5';

const LOGIN_API = '/php/api/login.api.php';
const CHECK_USERNAME_API = '/php/api/check-username.api.php';
const TOKEN_KEY = 'agent_token';

@Injectable({ providedIn: 'root' })
export class AuthService {

  isLoggedIn = signal(this.tokenValid());

  tokenValid(): boolean {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return false;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp * 1000 > Date.now();
    } catch {
      return false;
    }
  }

  constructor(private http: HttpClient, private router: Router) {}

  checkUsername(username: string) {
    return this.http.post<{ exists: boolean }>(CHECK_USERNAME_API, { username });
  }

  login(username: string, password: string) {
    const hashed = Md5.hashStr(password);
    return this.http.post<{ token: string }>(LOGIN_API, { username, password: hashed }).pipe(
      tap(res => {
        localStorage.setItem(TOKEN_KEY, res.token);
        this.isLoggedIn.set(true);
      })
    );
  }

  logout() {
    localStorage.removeItem(TOKEN_KEY);
    this.isLoggedIn.set(false);
    this.router.navigate(['/agent-hub/admin/login']);
  }

  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }
}
